import { Injectable } from "@angular/core";
import { NetworkService } from 'src/app/configuration/network.service';
import { Observable, of } from 'rxjs';
import { API } from 'src/app/configuration/end-points';
import { tap } from 'rxjs/operators';

@Injectable()
export class DropDownService {
  [x: string]: any;
  constructor(private networkService: NetworkService) { }

}
